import { http } from "./service.js";
const api = {
  login(data) {
    //登录
    return http.post("/api/login/useOpenIdPWLogin", data);
  },
  resetPwd(data) {
    //重置密码
    return http.post("/api/login/changePassword", data);
  },
  getEnrollmentSettings(data) {
    //获取全部课程列表
    return http.post("/api/enrollment/getEnrollmentSettings", data);
  },
  getCourseDetail(data) {
    //获取课程详情--机构课
    return http.post("/api/course/getCourse", data);
  },
  getEnrollmentById(data) {
    //获取课程详情--校内,特色课
    return http.post("/api/enrollment/getEnrollmentById", data);
  },
  studentEnrollment(data) {
    //学生报名
    return http.post("/api/enrollment/student_enrollment", data);
  },
  geCourseRegistrationList(data) {
    //学生的已报名课程列表
    return http.post("/api/enrollment/geCourseRegistrationList", data);
  },
  cancelStudentEnrollment(data) {
    //学生撤销报名：{ service_class_student_id }（getEnrollmentById 返回的新字段）
    return http.post("/api/enrollment/cancelEnrollmentById", data);
  },

  getChildren(data) {
    //获取用户的孩子
    return http.post("/api/user/getStudentList", data);
  },

  getChargeList(data) {
    //学生缴费单列表
    return http.post("/api/studentCharge/paymentList", data);
  },
  getPaymentDetail(data) {
    //获取学生缴费单详情
    return http.post("/api/studentCharge/paymentDetail", data);
  },
  getOpenId(data) {
    //用 code 换取微信 openid
    return http.post("/api/login/getOpenId", data);
  },
  weChatPay(data) {
    return http.post("/api/weixinPay/payment", data);
  },

  // ---- 新增：课程排课相关 ----
  // 获取某日期课程安排（老师今日课程）
  getCourseScheduleByDate(data) {
    return http.post("/api/courseSchedule/getCourseScheduleByDate", data);
  },
  // 获取某月课程安排（日历打点）
  getCourseScheduleByMonth(data) {
    return http.post("/api/courseSchedule/getCourseScheduleByMonth", data);
  },

  // ---- 新增：考勤相关 ----
  // 获取学生月考勤（家长）
  getStudentAttendance(data) {
    return http.post("/api/attendance/getStudentAttendance", data);
  },
  // 获取学生某日考勤详情（家长）
  getStudentAttendanceByDate(data) {
    return http.post("/api/attendance/getStudentAttendanceByDate", data);
  },
  // 获取老师月考勤（老师）
  getTeacherAttendance(data) {
    return http.post("/api/attendance/getTeacherAttendance", data);
  },
  getTeacherAttendanceByDate(data) {
    return http.post("/api/attendance/getTeacherAttendanceByDate", data);
  },
  // 教师课时费（按老师+时间段+学校汇总；后端接口待接入，路径先约定好）
  // 参数：{ teacher_id, start_date, end_date, school_id, type }
  // 返回 result: { total, list: [{ date, class_name, fee }] }
  getTeacherClassFee(data) {
    return http.post("/api/attendance/getTeacherClassFee", data);
  },

  // 班主任查看本班某日学生出勤情况
  // 参数：{ sid, class_id, search_date }
  // 返回 result 为扁平学生数组：每项含 is_leave(0/1) 与 courses[]（每项 is_attendance 0/1）
  studentDateAttendance(data) {
    return http.post("/api/teacher/studentDateAttendance", data);
  },

  // ---- 新增：签到相关 ----
  // 获取班级列表
  getClassList(data) {
    return http.post("/api/serviceClass/getServiceClassList", data);
  },

  // 获取学生考勤状态（签到页面用）
  getAttendanceStatus(data) {
    return http.post("/api/attendance/getAttendanceStatus", data);
  },

  // 巡课查看班级详情（学生考勤列表）
  // 参数：{ sid, service_class_id, search_date }
  // 返回结构同 getAttendanceStatus（result.student_list + attendance_status）
  dutyGetServiceClassInfo(data) {
    return http.post("/api/serviceClass/dutyGetServiceClassInfo", data);
  },

  // 老师提交全班考勤
  addAttendance(data) {
    return http.post("/api/attendance/addAttendance", data);
  },

  // 老师提交单个学生考勤
  addStudentAttendance(data) {
    return http.post("/api/attendance/addStudentAttendance", data);
  },

  //班主任提交单个学生考勤
  headTeacheraddStudentAttendance(data){
    return http.post("/api/attendance/headTeacheraddStudentAttendance", data);
  },

  // ---- 新增：请假相关 ----
  // 家长提交请假申请
  addLeave(data) {
    return http.post("/api/studentLeave/addLeave", data);
  },
  // 家长查看请假记录
  getLeaveListByUserId(data) {
    return http.post("/api/studentLeave/getLeaveListByUserId", data);
  },
  // 老师获取请假列表
  getLeaveListByTeacherId(data) {
    return http.post("/api/studentLeave/getLeaveListByTeacherId", data);
  },
  recordLeave(data) {
    return http.post("/api/studentLeave/recordLeave", data);
  },

  //学生课程表接口
  getStudentCourseSchedule(data) {
    return http.post("/api/courseSchedule/getStudentCourseSchedule", data);
  },
  
  //260729--------------
  // 班主任管理的班级列表（重命名为 getManageClassList，避免覆盖签到用的 getClassList）
  getManageClassList(data) {
    return http.post("/api/PClass/classList", data);
  },
  // 班级学生成员列表（含该生当前请假信息）
  getStudentList(data) {
    return http.post("/api/PClass/studentList", data);
  },
  // ---- 兴趣班管理（学生维度）----
  // 报班管理——单接口返回 join(已加入) + notJoin(未加入)，均按星期分组；
  // 参数：{ student_id }；sign_up=1 已加入 / 2 未加入
  getStudentClassList(data) {
    return http.post("/api/serviceClass/getServiceClassByStudent", data);
  },
  // 加入课后服务班级：sid, student_id, service_class_id（班级唯一标识，非 id）
  joinClass(data) {
    return http.post("/api/serviceClass/joinServiceClass", data);
  },
  // 退出课后服务班级：sid, student_id, service_class_id
  quitClass(data) {
    return http.post("/api/serviceClass/dropServiceClass", data);
  },

  //巡课老师获取全校某天课后服务班级
  getAllServiceClassListByDate(data){
    return http.post("/api/serviceClass/getAllServiceClassListByDate", data);
  },

  // 巡课老师签到：{ sid, teacher_id, attendance_date, att_status }；att_status：1=签到，2=取消
  dutyTeacherAttendance(data){
    return http.post("/api/attendance/dutyTeacherAttendance", data);
  },

  // 查询巡课老师某天是否已签到：{ sid, teacher_id, attendance_date }
  // 返回：{ code, result: { attendance_status } }，attendance_status =1 已签到 / 0 未签到
  getDutyTeacherAttendance(data){
    return http.post("/api/attendance/getDutyTeacherAttendance", data);
  },

  // 巡课老师按月出勤（月历打点）：{ sid, teacher_id, year, month, school_id }
  // 返回：{ code, result: { "2026-08-01": 1, ... } }，1=已签到
  getDutyTeacherAttendanceByMonth(data){
    return http.post("/api/attendance/getDutyTeacherAttendanceByMonth", data);
    
  },


};



export default api;
